import React, { useEffect } from 'react';
import AdminLayout from './AdminLayout';
import { AdminRouteIds } from './AdminRoutes';
import ShipmentDetailsForm from '../ShipmentDetailsForm';
import { useNavigate, useParams } from 'react-router-dom';
import { logError } from '../../utilities';
import { toast } from 'react-toastify';
import { getShipment } from '../../api/adminApi';
import { AdminShipmentWithLatestStatusModel } from '../../apiModels/adminShipmentWithLatestStatusModel';
import LoadingIcon from '../LoadingIcon';


export default function ShipmentDetails(props: {
    adminMenuId: number;
    canEdit: boolean;
}) {
    const { trackingNumber } = useParams();
    const [ isDetailsLoading, setIsDetailsLoading ] = React.useState<boolean>(false);
    const [ hasError, setHasError ] = React.useState<boolean>(false);
    const [ shipment, setShipment ] = React.useState<AdminShipmentWithLatestStatusModel | undefined>(undefined);
    const notifyUserOfError = (err: string) => toast(err, { type: 'error' });
    const navigate = useNavigate();

    const loadShipment = async() => {
        if (trackingNumber === undefined) {
            setHasError(true);
            return;
        }

        setIsDetailsLoading(true);

        try {
            const s = await getShipment(trackingNumber);
            setShipment(s);
            setIsDetailsLoading(false);
        } 
        catch (error: any) {
            if (error instanceof Error) {
                notifyUserOfError(error.message);
            }
    
            logError(error);
            setIsDetailsLoading(false);
            setHasError(true);
        }
    };

    useEffect(() => {
        loadShipment();
    }, []);

    if (isDetailsLoading) {
        return (<LoadingIcon />);
    }
    else if (hasError || shipment === undefined) {
        return (
            <AdminLayout selectedId={props.adminMenuId}>
                <div className='text-center text-warning'>
                    <h3><i className='bi bi-exclamation-triangle-fill me-2' /> Invalid Shipment Details</h3>
                </div>
            </AdminLayout>
        );
    }

    const getDetailsContent = () => {
        if (isDetailsLoading){
            return <LoadingIcon />;
        }
        else if (hasError || shipment === undefined) {
            return (
                <div className='text-center text-warning mt-5'>
                    <h3><i className='bi bi-exclamation-triangle-fill me-2' /> Invalid Shipment Details</h3>
                </div>
            );
        }
        else {
            return <ShipmentDetailsForm shipment={shipment}
                loadShipment={loadShipment}
                canEdit={props.canEdit} />
        }
    }

    return (
        <AdminLayout selectedId={props.adminMenuId}>
            <div className='row'>
                <div className='col'>
                    <h3>Shipment Details</h3>        
                </div>
                <div className='col text-end'>
                    <button className='btn btn-default' onClick={() => navigate("/admin/shipments") }>
                        <i className='bi bi-arrow-left'></i> Back to List
                    </button>
                    {props.canEdit &&
                    <button className='btn btn-primary' onClick={() => navigate(`/admin/shipments/edit/${trackingNumber}`)}>
                        <i className='bi bi-pencil-square me-2'></i> Edit
                    </button>}
                </div>
            </div>
            {getDetailsContent()}
        </AdminLayout>   
    );
}
